// extracted by mini-css-extract-plugin
module.exports = {"form":"Logout_form_2sn9_","error":"Logout_error_2C3Sy","logo":"Logout_logo_1eAfY"};